import { schemaCommon } from "common/bit/form/FormikSchema"
import * as yup from "yup"

const schemaCarFleet = yup
  .object({
    subject: yup.string().required("שדה חובה"),
    firstName: schemaCommon.firstName,
    lastName: schemaCommon.lastName,
    email: schemaCommon.email,
    phoneNumber: schemaCommon.phoneNumber,
    organization: schemaCommon.organization,
    organizationTitle: schemaCommon.organizationTitle,
    approveMailingList: schemaCommon.checkboxNotRequired,
    message: yup.string().max(500, "יש להזין עד 500 תווים בלבד"),
  })
  .defined()

export const initialFormStatesCarFleet: yup.InferType<typeof schemaCarFleet> = {
  subject: "",
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  message: "",
  organization: "",
  organizationTitle: "",
  approveMailingList: false,
}

export default schemaCarFleet
